/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaChevronDown, FaChevronUp, FaPaperPlane, FaRegPlayCircle, FaRegStopCircle } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../../../../components/CheckboxCmp'
import { ElementoTooltip } from '../../../../../../components/ElementoTooltip'
import { ElementoTooltipCmp } from '../../../../../../components/ElementoTooltipCmp'
import { iConvite } from '../../../../../../interfaces'
import { CircleText } from '../CircleText'
import { TableDiv } from './styles'

interface iTabelaprops {
  rows: iConvite[]
  reaberto: boolean
  anonima?: boolean
  selecionados?: string[]
  onCheck: (ids: string[], all?: boolean) => void
  onSend: (id: string) => void
  onInterromper: (email: string) => void
  onReabrir: (email: string) => void
  isEdit?: boolean
  pesquisaEncerrada?: boolean
}

export const TableConvites: React.FC<iTabelaprops> = ({ rows, isEdit, selecionados, anonima, onCheck, onSend, pesquisaEncerrada, reaberto, onInterromper, onReabrir }) => {
  const [Rows, setRows] = useState<iConvite[]>([])

  useEffect(() => {
    setRows(rows)
  }, [rows])

  function SelecionarTodos(check: boolean): void {
    onCheck([], check)
  }

  const [Ordenacao, setOrdenacao] = useState(false)
  const [UltimoFiltro, setUltimoFiltro] = useState<number>()

  function OrdenarTabela(filtro: number): void {
    if (!(!Ordenacao && UltimoFiltro !== filtro)) {
      setOrdenacao(!Ordenacao)
    }
    setUltimoFiltro(filtro)
  }

  useEffect(() => {
    const copy = [...rows]
    if (UltimoFiltro === 1) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.nome && b.nome) {
          return b.nome.localeCompare(a.nome)
        } else if (Ordenacao && a.nome && b.nome) {
          return a.nome.localeCompare(b.nome)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 2) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.email && b.email) {
          return b.email.localeCompare(a.email)
        } else if (Ordenacao && a.email && b.email) {
          return a.email.localeCompare(b.email)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 3) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.area && b.area) {
          return b.area.localeCompare(a.area)
        } else if (Ordenacao && a.area && b.area) {
          return a.area.localeCompare(b.area)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 4) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.status && b.status) {
          return b.status.localeCompare(a.status)
        } else if (Ordenacao && a.status && b.status) {
          return a.status.localeCompare(b.status)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 5) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.qtdCiclosFeitos && b.qtdCiclosFeitos) {
          return b.qtdCiclosFeitos - a.qtdCiclosFeitos
        } else if (Ordenacao && a.qtdCiclosFeitos && b.qtdCiclosFeitos) {
          return a.qtdCiclosFeitos - b.qtdCiclosFeitos
        } else {
          return 0
        }
      })
    }
    setRows(copy)
  }, [Ordenacao, UltimoFiltro, rows])

  function ObterCor(e: iConvite): string {
    if (e.interrompido) return 'Red'
    if (reaberto) return 'c5'
    if (!anonima) {
      return e.status === 'Não enviado' ? 'c5' : e.status === 'Enviado' ? 'Rosa' : e.status === 'Respondido' ? 'v2' : ''
    } else {
      return e.status === 'Respondido' || e.status === 'Enviado' ? 'Rosa' : 'c5'
    }
  }

  return (
    <TableDiv>
      <table>
        <thead>
          <tr>
            {isEdit && <th>
              <Flex gap={'0.50rem'}>
                <span>Selecionar todos </span>
                <CheckboxCmp OnChange={SelecionarTodos}/>
              </Flex></th>}
            <th onClick={() => OrdenarTabela(1)}>
              <div>Nome {UltimoFiltro === 1 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            <th onClick={() => OrdenarTabela(2)}>
              <div>Email {UltimoFiltro === 2 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            <th onClick={() => OrdenarTabela(3)}>
              <div>Área {UltimoFiltro === 3 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
            </th>
            {!isEdit &&
              <th onClick={() => OrdenarTabela(4)}>
                <div>Status {UltimoFiltro === 4 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
              </th>
            }
            {Rows.some(e => e.qtdCiclosFeitos !== undefined && e.qtdCiclosFeitos !== null) &&
              <th style={{ maxWidth: '10rem' }} onClick={() => OrdenarTabela(5)}>
                <div>Quantidade de ciclos concluídos {UltimoFiltro === 5 && !Ordenacao ? <FaChevronUp/> : <FaChevronDown/>}</div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          {
            Rows.map((e, i) => {
              return (
                <tr key={i}>
                  {isEdit &&
                    (<td>
                      {e.etapaVinculada
                        ? (
                          <ElementoTooltip label='Não é possível selecionar convite de etapa' bg={'red'}>
                            <CheckboxCmp isDisabled={e.etapaVinculada} isChecked={selecionados?.find(r => r === e.id) !== undefined} OnChange={() => onCheck([e.id])}/>
                          </ElementoTooltip>
                          )
                        : (
                          <CheckboxCmp isDisabled={e.etapaVinculada} isChecked={selecionados?.find(r => r === e.id) !== undefined} OnChange={() => onCheck(e.convitesExtras ? e.convitesExtras : [e.id])}/>
                          )}
                    </td>
                    )
                  }
                  <td>{e.nome}</td>
                  <td>{e.email}</td>
                  <td>{e.area}</td>
                  {!isEdit && <td>
                    <Flex justifyContent={'center'} gap={'1rem'} flexWrap={'wrap'}>
                      <CircleText fontsize='14px'
                        varColorCircle={ObterCor(e)}
                        varColorText=''
                        hiddenNumber
                      >
                        {e.interrompido ? 'Interrompido' : reaberto ? 'Aguardando disparos' : !anonima ? e.status : e.status === 'Respondido' || e.status === 'Enviado' ? 'Enviado' : 'Não enviado'}
                      </CircleText>
                      {
                        !reaberto && !e.interrompido && (e.status === 'Não enviado' && !anonima) && (
                          <ButtonCmp
                            onClick={() => onSend(e.id)}
                            leftIcon={<FaPaperPlane />}
                            VarColor='Green2'
                            small
                            isDisabled={pesquisaEncerrada || !e.liberado}
                          >Enviar</ButtonCmp>
                        )
                      }

                      {
                        !e.interrompido && !reaberto && (e.status === 'Enviado' && !anonima) && (
                          <ButtonCmp
                            onClick={() => onSend(e.id)}
                            leftIcon={<FaPaperPlane />}
                            VarColor='Rosa'
                            small
                            isDisabled={pesquisaEncerrada || !e.liberado}
                          >Reenviar</ButtonCmp>
                        )
                      }
                    </Flex>
                  </td>}
                  {e.qtdCiclosFeitos !== undefined && e.qtdCiclosFeitos !== null && <td style={{ color: 'var(--Green3)' }}>
                    <Flex alignItems={'center'} justifyContent={'center'} gap={'1rem'}>
                      {e.qtdCiclosFeitos}
                      {!e.interrompido && <ElementoTooltipCmp label='Interromper ciclos' bg={'var(--Red)'}>
                        <ButtonCmp small onClick={() => onInterromper(e.email)} VarColor={'Red'}><FaRegStopCircle/></ButtonCmp>
                      </ElementoTooltipCmp>}
                      {e.interrompido && <ElementoTooltipCmp label='Retomar ciclos' bg={'var(--Green2)'}>
                        <ButtonCmp small onClick={() => onReabrir(e.email)} VarColor={'Green2'}><FaRegPlayCircle/></ButtonCmp>
                      </ElementoTooltipCmp>}
                    </Flex>
                  </td>}
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </TableDiv>
  )
}
